// extracted by mini-css-extract-plugin
export default {"pageTitle":"PageTitle_pageTitle__ASBUq","color-green":"PageTitle_color-green__PhAn9","color-orange":"PageTitle_color-orange__pl4JA","color-pink":"PageTitle_color-pink__nexHn"};